var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8FFCF3",
    d: "M12 3.428v6.335l5.357 2.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CABCF8",
    d: "m12 3.428l-5.357 8.73L12 9.764z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBA7F5",
    d: "M12 16.264v4.307l5.357-7.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74A0F3",
    d: "M12 20.571v-4.307l-5.357-3.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBA7F5",
    d: "m12 15.266l5.357-3.107L12 9.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74A0F3",
    d: "M6.643 12.159L12 15.266V9.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202699",
    fillRule: "evenodd",
    d: "m12 15.266l-5.357-3.107L12 3.428l5.357 8.73zm-5.002-3.36l4.916-8.01V9.72zm-.073.218l4.989-2.216v5.109zm5.16-2.216v5.109l4.985-2.893zm0-.188l4.916 2.186l-4.916-8.01z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202699",
    fillRule: "evenodd",
    d: "m12 16.196l-5.357-3.043L12 20.57l5.357-7.418zm-4.757-2.508l4.671 2.658v3.814zm4.842 2.658v3.814l4.672-6.472z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.865424f24287794cbfe2dce1b0344833.svg";
export { ForwardRef as ReactComponent };